import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OwnershipResponseDto, OwnershipUpsertRequest, AddOwnershipLargeShareholderRequest, OwnershipBoardMemberDto, OwnershipExecutiveMemberDto } from '../../models/api/companyOwnershipDto';
import { YearlyResource } from '../../models/api/yearlyResource';

export interface OwnershipContext {
  boardType?: number;
  boardMembers: OwnershipBoardMemberDto[];
  executiveMembers: OwnershipExecutiveMemberDto[];
}

@Injectable({
  providedIn: 'root'
})
export class CompanyOwnershipService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  getOwnership(companyId: string, year?: number): Observable<YearlyResource<OwnershipResponseDto, OwnershipContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<OwnershipResponseDto, OwnershipContext>>(
      `${this.apiUrl}/${companyId}/ownership`,
      { params }
    );
  }

  updateOwnership(companyId: string, request: OwnershipUpsertRequest): Observable<YearlyResource<OwnershipResponseDto, OwnershipContext>> {
    return this.http.put<YearlyResource<OwnershipResponseDto, OwnershipContext>>(`${this.apiUrl}/${companyId}/ownership`, request);
  }

  addLargeShareholder(companyId: string, request: AddOwnershipLargeShareholderRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${companyId}/ownership/large-shareholders`, request);
  }

  deleteLargeShareholder(companyId: string, largeShareholderId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/ownership/large-shareholders/${largeShareholderId}`, { params });
  }
}
